import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fhMenuFeatures'
})
export class FhMenuFeaturesPipe implements PipeTransform {
  transform(list: any[], validateFeature: boolean) {
    if (validateFeature) {
      return list.filter((item) => item.visible);
    } else {
      return list;
    }
  }
}
